import { render, staticRenderFns } from "./ExpencesList.vue?vue&type=template&id=364c6672&"
import script from "./ExpencesList.vue?vue&type=script&lang=js&"
export * from "./ExpencesList.vue?vue&type=script&lang=js&"
import style0 from "./ExpencesList.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports